import api from './api';

export interface Supplier {
  id: number;
  name: string;
  code: string;
  country: string;
  contactEmail?: string;
  isActive: boolean;
}

export interface CreateSupplierRequest {
  name: string;
  code: string;
  country: string;
  contactEmail?: string;
}

export interface UpdateSupplierRequest extends CreateSupplierRequest {
  isActive: boolean;
}

export const supplierService = {
  getAll: () => api.get<Supplier[]>('/suppliers'),
  
  getById: (id: number) => api.get<Supplier>(`/suppliers/${id}`),
  
  search: (search: string = '', limit: number = 20) =>
    api.get<Supplier[]>(`/suppliers/search?search=${encodeURIComponent(search)}&limit=${limit}`),
  
  create: (data: CreateSupplierRequest) =>
    api.post<Supplier>('/suppliers', data),
  
  update: (id: number, data: UpdateSupplierRequest) =>
    api.put<Supplier>(`/suppliers/${id}`, data),
  
  delete: (id: number) =>
    api.delete(`/suppliers/${id}`),
};
